module.exports = __webpack_public_path__ + "group-16.svg?a14883dcee13ee17f3b12a31ea7f7112";